export enum SharedQueries {
	// Brands
	GET_BRANDS_NO_IDS = `
    query Brands ($companyId: Int!, $search: String) {
        brands(
            companyId: $companyId,
            where: {
                brand: {
                    active: { eq: true }
                    cancelled: { eq: false }
                    name: { contains: $search }
                }
            }
            order: { brand: {name: ASC} }
        ) {
            nodes {
                brandId
                hasSizeGroup
                brand {
                    name
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_BRANDS = `
    query Brands ($companyId: Int!, $brandIds: [Int!], $search: String) {
        brands(
            companyId: $companyId,
            where: {
                brand: {
                    active: { eq: true }
                    cancelled: { eq: false }
                    id: { in: $brandIds }
                    name: { contains: $search }
                }
            }
            order: { brand: {name: ASC} }

        ) {
            nodes {
                brandId
                hasSizeGroup
                brand {
                    name
                }
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,

	// Categories
	GET_CATEGORIES_ALL = `
    query Category($companyId: Int!, $search: String) {
        category(
        companyId: $companyId
        where: {name: {contains: $search}}
        order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_CATEGORIES_NO_IDS = `
    query Category($companyId: Int!, $brandIds:[Int]!) {
        category(
            companyId: $companyId
            where: { styles: { some: { brandId: { in: $brandIds } } } }
            order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                endCursor
            }
        }
    }
    `,
	GET_CATEGORIES_BY_IDS = `
    query Category($companyId: Int!, $categoryIds: [Int!]) {
        category(
        companyId: $companyId
        where: { id: { in: $categoryIds }}
        order: { name: ASC }
        ) {
            nodes {
                id
                name
            }
        }
    }
    `,

	// Colors
	GET_COLORS_BY_MODEL = `
    query Colors($companyId: Int!, $first: Int, $after: String, $modelId: Int!, $search: String) {
        colors(
            companyId: $companyId
            first: $first
            after: $after
            where: { schemaTeamColors: { some: { schema: { modelId: { eq: $modelId } } } }             
                or: [
                    { code: { contains: $search } }
                    { finalColorName: { contains: $search } }
                ]
            }
        ) {
            nodes {
                id
                code
                finalColorName
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
	GET_COLORS_BY_IDS = `
    query Colors($companyId: Int!, $colorIds: [Int]!) {
        colors(companyId: $companyId, where: { id: { in: $colorIds } }) {
            nodes {
                id
                code
                name
                finalColorName
            }
        }
    }
    `,

	// Size Groups
	GET_SIZE_GROUPS_NO_IDS = `
    query SizeGroups($companyId: Int!, $search: String) {
        sizeGroups(
            companyId: $companyId
            order: { ord: ASC }
            where: { or: [{ active: { eq: true } }, { cancelled: { eq: false } }], and: {name: {contains: $search}} }
        ) {
            nodes {
                id
                name
            }
        }
    }
    `,
	GET_SIZE_GROUPS = `
    query SizeGroups($companyId: Int!, $sizeGroupIds: [Int]) {
        sizeGroups(companyId: $companyId, where: { id: { in: $sizeGroupIds } }) {
            nodes {
                id
                name
            }
        }
    }
    `,
	GET_SIZE_GROUPS_BY_BRAND = `
    query SizeGroupsByBrand($companyId: Int!, $brandId: Int!) {
        sizeGroupsByBrand(companyId: $companyId, brandId: $brandId) {
            nodes {
                id
                name
            }
        }
    }
    `,

	// Style Shots Comments
	GET_STYLE_SHOTS_COMMENTS = `
    query StyleShotsComments($companyId: Int!, $currentUserId: Int!, $orderId: Int!, $paginationPage: Int!, $paginationSize: Int!, $modelId: Int!, $colorId: Int!, $sizeGroupId: Int) {
        styleShotsComments(
            companyId: $companyId
            currentUserId: $currentUserId
            orderId: $orderId
            paginationPage: $paginationPage
            paginationSize: $paginationSize
            modelId: $modelId
            colorId: $colorId
            sizeGroupId: $sizeGroupId
        ) {
            nodes {
                comments
                imgPath
                creationDate
                isMine
            }
        }
    }
    `
}

